import { Chapter } from 'src/app/models/chapter';
import { Transcript } from 'src/app/models/transcript';
import { FormOverlay } from 'src/app/models/form-overlay';
import { FormExpand } from 'src/app/models/form-expand';
import { Lp } from 'src/app/models/lp';
import { Live } from 'src/app/models/live';
import { CtaSimple } from 'src/app/models/cta-simple';
import { VideoTagUserVideo } from './video-tag-user-video';

export class UserVideo{

  hash:string;
  hashPublic:string;
  enable: Enable;
  lp: Lp;
  live: Live;
  username:string;
  title:string = "";
  description:string = "";
  time:number = 0;
  color:string = "#666";
  thumbnailPath:string;
  templateText:string;  
  sources:Array<Source> = [];
  chapters:Array<Chapter> = [];
  transcripts:Array<Transcript> = [];
  ctaSimple:CtaSimple;
  formOverlay:FormOverlay;
  formExpand:FormExpand;
  questionnaireEnable:boolean;
  questionnaireData:Object;
  videoTagUserVideos: Array<VideoTagUserVideo> = [];
  registDate:Date;
  
  constructor(object = null){

    if(object){
      this.set(object);
    }
  };

  set(object){
    if(object.hash){
      this.hash = object.hash;
    }
    if(object.hashPublic){
      this.hashPublic = object.hashPublic;
    }
    if(object.enable){
      this.enable = object.enable;
    }
    if(object.lp){
      this.lp = new Lp(object.lp);
      console.log(this.lp);
    }      
    if(object.live){
      this.live = new Live(object.live);
    }  
    if(object.username){
      this.username = object.username;
    }
    if(object.title){
      this.title = object.title;
    }
    if(object.summary){
      this.description = object.summary;
    }
    if(object.time){
      this.time = parseInt(object.time);
    }
    if(object.color){
      this.color = object.color;
    }
    if(object.thumbnailPath){
      this.thumbnailPath = object.thumbnailPath;
    }
    if(object.templateText){
      this.templateText = object.templateText;
    }
    if(object.sources){
      for(let sourceObject of object.sources){
        let source:Source = {
          label: sourceObject.label,
          file: sourceObject.file,
        };
        this.sources.push(source);
      }
    }
    if(object.chapters){
      for(let chapterObject of object.chapters){
        let chapter:Chapter = new Chapter(chapterObject);
        this.chapters.push(chapter);
      }
    }
    if(object.transcripts){
      for(let transcriptObject of object.transcripts){
        let transcript:Transcript = new Transcript(transcriptObject);
        this.transcripts.push(transcript);
      }
    }
    if(object.ctaSimple){
      this.ctaSimple = new CtaSimple(object.ctaSimple);
    }
    if(object.formOverlay){
      this.formOverlay = new FormOverlay(object.formOverlay);
    }
    if(object.formExpand){
      this.formExpand = new FormExpand(object.formExpand);
    }    
    if(object.registDate){
      this.registDate = new Date(object.registDate * 1000);
    }
    if(object.questionnaireEnable){
      this.questionnaireEnable = object.questionnaireEnable;
    }

    if(object.questionnaireData){
      this.questionnaireData = object.questionnaireData;
    }
    if(object.videoTagSectionData){
      try {
        if(Array.isArray(object.videoTagSectionData.videoTagUserVideos)){
          for(const videoTagUserVideoObject of object.videoTagSectionData.videoTagUserVideos){
            this.videoTagUserVideos.push(new VideoTagUserVideo(videoTagUserVideoObject));
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  getUserVideoPageUrl(){
    return "/owner/video-detail/" + this.hash;
  }
}

export interface Source{
  label:string,
  file:string,    
}

export enum Enable {
  YES = 1, // 公開
  NO = 2, // 非公開
}


  